import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { ADJUSTMENT_STATUS_TO_CHIP_CLASS, ADJUSTMENT_STATUS_TO_LABEL } from "../../constants"

import type { InventoryAdjustmentStatus } from "@/graphql/codegen/graphql"

interface AdjustmentHistoryStatusCellProps {
  status: InventoryAdjustmentStatus
}

export const AdjustmentHistoryStatusCell: FC<AdjustmentHistoryStatusCellProps> = ({ status }) => (
  <Chip
    className={twMerge("h-6 rounded text-xs", ADJUSTMENT_STATUS_TO_CHIP_CLASS[status])}
    label={ADJUSTMENT_STATUS_TO_LABEL[status]}
    size='small'
  />
)
